import React from 'react'

export default function ChevronDown() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="6" height="4" fill="none" viewBox="0 0 6 4">
      <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="m1 1 2 2 2-2" />
    </svg>
  )
}
